import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { CurrencyOption } from 'typings/currency'

const initialState: Omit<CurrencyOption, 'restriction'>[] = []

const selectedCurrencySlices = createSlice({
  name: 'selectCurrency',
  initialState,
  reducers: {
    selectCurrency(state, action: PayloadAction<Omit<CurrencyOption, 'restriction'>>) {
      return state.filter(({ id }) => id !== action.payload.id).concat(action.payload)
    },
  },
})

export const { selectCurrency } = selectedCurrencySlices.actions

export default selectedCurrencySlices.reducer
